module.exports = __webpack_public_path__ + "img/trauma-and-assault.a5d04a9a.png";